import Vue from 'vue';
import Vuex from 'vuex';
// import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  // plugins: [createPersistedState()],
  state: {
    view: 'default', // 'default', 'riddles'
    stage: 0,
  },
  mutations: {
    setView(state, view) {
      state.view = view;
    },
    setStage(state, stage) {
      state.stage = stage;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js